import React from 'react';
// import styleCSS from './Content.module.css';
import ImageSliderContainer from "../ImageSlider/ImageSliderContainer";

const Content = () => {
    return (
        <div>
            <ImageSliderContainer/>
        </div>
    );
};

export default Content;